import { Injectable } from '@angular/core';
import { utils as XLSXUtils, writeFile } from 'xlsx';
import { WorkBook, WorkSheet } from 'xlsx/types'
import { ExportExcelModel } from '../models/export-excel.model';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  fileExtension = '.xlsx';

  constructor() { }

  public exportAsExcel({
    data,
    fileName,
    sheetName,
  }: ExportExcelModel): void {

    let workBook: WorkBook;

    const workSheet: WorkSheet = XLSXUtils.json_to_sheet(data.rows, { skipHeader: false });

    const rowHeaders = Object.keys(Object.values(data.rows)[0]);

    for (var numericColmn of data.numericColumns) {

      var indexOfColumn = _.indexOf(rowHeaders, numericColmn);

      if (indexOfColumn < 0) {
        continue;
      }

      for (var i = 1; i <= data.rows.length + 1; ++i) {

        var ref = XLSXUtils.encode_cell({ r: i, c: indexOfColumn });
        if (!workSheet[ref]) {
          continue;
        }
        workSheet[ref].t = 'n';
      }
    }


    workBook = XLSXUtils.book_new();
    XLSXUtils.book_append_sheet(workBook, workSheet, sheetName);
    writeFile(workBook, `${fileName}${this.fileExtension}`);
  }

}
